var colors = {
  blueHover: 'var(--deprecated-legacy-blue-hover)',
  bold: 'var(--wcds-colors-red-50)',
  extendedGrey: 'var(--deprecated-legacy-colors-primary-extended-grey)',
  grey: 'var(--deprecated-legacy-colors-primary-grey)',
  greyish: 'var(--deprecated-legacy-colors-indigo-90-alpha-60)',
  human: 'var(--wcds-colors-pink-50)',
  lightBlue: 'var(--deprecated-legacy-colors-blue-70-alpha-10)',
  lightGray: 'var(--deprecated-legacy-colors-indigo-90-alpha-10)',
  lightHuman: 'var(--wcds-colors-pink-20)',
  lightOutspoken: 'var(--wcds-colors-yellow-20)',
  lightPassionate: 'var(--wcds-colors-blue-10)',
  lightPink: 'var(--deprecated-legacy-colors-pink-50-alpha-40)',
  lightYellow: 'var(--deprecated-legacy-colors-yellow-60-alpha-30)',
  outspoken: 'var(--wcds-colors-yellow-60)',
  passionate: 'var(--wcds-colors-blue-70)',
  primaryBlue: 'var(--deprecated-legacy-colors-primary-blue-idle)',
  primaryBlueActive: 'var(--deprecated-legacy-colors-primary-blue-active)',
  primaryBlueHover: 'var(--deprecated-legacy-colors-primary-blue-hover)',
  primaryIndigo: 'var(--wcds-colors-indigo-90)',
  primaryWhite: 'var(--wcds-colors-white)',
  secondaryGrey: 'var(--deprecated-legacy-colors-white-alpha-75)',

  /**
   * Onboarding theme
   */
  dimmedBlue: 'var(--deprecated-legacy-colors-indigo-90-alpha-90)',
  dimmedGray: 'var(--deprecated-legacy-dimmed-gray)',
  dimmestGray: 'var(--deprecated-legacy-dimmest-gray)',
  overlayDark: 'var(--deprecated-legacy-colors-indigo-90-alpha-90)',
  placeholderColor: 'var(--deprecated-legacy-placeholder-color)',
  primary40: 'var(--deprecated-legacy-primary-40)',
  primary80: 'var(--deprecated-legacy-primary-80)',
  solutionsGray: 'var(--deprecated-legacy-solutions-gray)',
  workshopGray: 'var(--deprecated-legacy-colors-indigo-90-alpha-3)'
};
export default colors;